import React from "react";
import {
  Box,
  Flex,
  Grid,
  GridItem,
  Heading,
  Spinner,
  Text,
  Alert,
  AlertIcon,
  useColorModeValue,
} from "@chakra-ui/react";
import { usePartner } from "hooks/usePartner";
import Card from "components/card/Card";

export default function PartnerProfile() {
  const { partner, loading, error } = usePartner();
  const headingColor = useColorModeValue("secondaryGray.900", "white");
  const mutedColor = useColorModeValue("secondaryGray.600", "secondaryGray.600");
  const labelColor = useColorModeValue("gray.400", "gray.500");

  if (loading) {
    return (
      <Flex justify="center" py={16}>
        <Spinner size="lg" color="brand.500" thickness="4px" />
      </Flex>
    );
  }

  if (error) {
    return (
      <Alert status="error" borderRadius="xl">
        <AlertIcon />
        {error}
      </Alert>
    );
  }

  if (!partner) {
    return (
      <Card py={8}>
        <Text textAlign="center" color={mutedColor}>
          Dados do parceiro não disponíveis.
        </Text>
      </Card>
    );
  }

  const fields = [
    { label: "Nome", value: partner.name },
    { label: "Email", value: partner.email },
    { label: "Telefone", value: partner.phone },
    { label: "Empresa", value: partner.companyName },
    { label: "CNPJ", value: partner.cnpj },
    { label: "Responsável", value: partner.responsibleName },
  ];

  const addr = partner.address;

  return (
    <Box>

      <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={6}>
        <GridItem colSpan={{ base: 1, lg: 2 }}>
          <Card>
            <Heading size="md" color={headingColor} mb={4}>
              Status da conta
            </Heading>
            <Flex align="center" gap={2}>
              <Box
                w="10px"
                h="10px"
                borderRadius="full"
                bg={partner.active ? "green.500" : "red.500"}
              />
              <Text fontSize="sm" color={headingColor}>
                {partner.active ? "Ativa" : "Inativa"}
              </Text>
            </Flex>
          </Card>
        </GridItem>
        <Card>
          <Heading size="md" color={headingColor} mb={4}>
            Dados gerais
          </Heading>
          <Flex direction="column" gap={4}>
            {fields.map((f) => (
              <Box key={f.label}>
                <Text fontSize="xs" fontWeight="medium" textTransform="uppercase" color={labelColor}>
                  {f.label}
                </Text>
                <Text mt={1} fontSize="sm" color={headingColor}>
                  {f.value || "—"}
                </Text>
              </Box>
            ))}
          </Flex>
        </Card>

        {addr && (
          <Card>
            <Heading size="md" color={headingColor} mb={4}>
              Endereço
            </Heading>
            <Flex direction="column" gap={1} fontSize="sm" color={mutedColor}>
              <Text>
                {addr.street}
                {addr.number ? `, ${addr.number}` : ""}
              </Text>
              {addr.complement && <Text>{addr.complement}</Text>}
              <Text>{addr.neighborhood}</Text>
              <Text>
                {addr.city} — {addr.state}
              </Text>
              {addr.zipCode && <Text>CEP: {addr.zipCode}</Text>}
            </Flex>
          </Card>
        )}
      </Grid>
    </Box>
  );
}
